export const GET_SENSOR_METRICS_REQUEST =
  '@sensor_details/GET_SENSOR_METRICS_REQUEST';
export const GET_SENSOR_METRICS_SUCCESS =
  '@sensor_details/GET_SENSOR_METRICS_SUCCESS';
export const GET_SENSOR_METRICS_FAILURE =
  '@sensor_details/GET_SENSOR_METRICS_FAILURE';

export const GET_SENSOR_CHART_REQUEST =
  '@sensor_details/GET_SENSOR_CHART_REQUEST';
export const GET_SENSOR_CHART_SUCCESS =
  '@sensor_details/GET_SENSOR_CHART_SUCCESS';
export const GET_SENSOR_CHART_FAILURE =
  '@sensor_details/GET_SENSOR_CHART_FAILURE';

export const GET_SENSOR_FULL_CHART_REQUEST =
  '@sensor_details/GET_SENSOR_FULL_CHART_REQUEST';
export const GET_SENSOR_FULL_CHART_SUCCESS =
  '@sensor_details/GET_SENSOR_FULL_CHART_SUCCESS';
export const GET_SENSOR_FULL_CHART_FAILURE =
  '@sensor_details/GET_SENSOR_FULL_CHART_FAILURE';

export const RESET_SENSOR_DETAILS = '@sensor_details/RESET_SENSOR_DETAILS';
